[
  {
    "id": "SWW-E6-L105-001",
    "module": "SpellingWW",
    "difficulty": 105,
    "difficultyTier": 5,
    "levelCode": "E6",
    "group": 6,
    "question": "Hij ... op de bank. (zitten)",
    "options": ["zit", "zitten", "zat", "gezeten"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tegenwoordige_tijd",
    "subSkill": "pv_hij_zij_het",
    "familyId": "SWW-TT-HIJ-ZIJ-HET-BASIS",
    "conceptId": "present_tense_third_person_basic",
    "variantIndex": 1,
    "explanation": "Onderwerp is 'hij' en het is nu, dus tegenwoordige tijd. De juiste persoonsvorm is: zit.",
    "distractorExplanations": {
      "1": "Dit is het hele werkwoord. In de zin heb je de persoonsvorm nodig: zit.",
      "2": "Dit is verleden tijd. Er staat geen tijdwoord zoals 'gisteren'.",
      "3": "Dit is het voltooid deelwoord. Dat gebruik je met 'heeft' of 'is': hij heeft gezeten."
    }
  },
  {
    "id": "SWW-E6-L105-002",
    "module": "SpellingWW",
    "difficulty": 105,
    "difficultyTier": 5,
    "levelCode": "E6",
    "group": 6,
    "question": "Gisteren ... ik mijn kamer op. (ruimen)",
    "options": ["ruimde", "ruimt", "ruimen", "geruimd"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verleden_tijd",
    "subSkill": "vt_zwak_context",
    "familyId": "SWW-VT-CONTEXT-GISTEREN",
    "conceptId": "past_tense_trigger_word_gisteren",
    "variantIndex": 2,
    "explanation": "Door 'gisteren' weet je dat het verleden tijd is. Van 'ruimen' is de verleden tijd: ruimde.",
    "distractorExplanations": {
      "1": "Dit is tegenwoordige tijd. 'Gisteren' vraagt om verleden tijd.",
      "2": "Dit is het hele werkwoord. Je hebt de persoonsvorm nodig: ruimde.",
      "3": "Dit is het voltooid deelwoord. Dat gebruik je met 'heb': ik heb geruimd."
    }
  },
  {
    "id": "SWW-E6-L105-003",
    "module": "SpellingWW",
    "difficulty": 105,
    "difficultyTier": 5,
    "levelCode": "E6",
    "group": 6,
    "question": "Wij ... morgen naar het bos. (fietsen)",
    "options": ["fietsen", "fietst", "fietsten", "gefietst"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tegenwoordige_tijd",
    "subSkill": "pv_meervoud",
    "familyId": "SWW-TT-MEERVOUD",
    "conceptId": "present_tense_plural_basic",
    "variantIndex": 1,
    "explanation": "Onderwerp is 'wij' (meervoud). In de tegenwoordige tijd gebruik je dan het hele werkwoord: fietsen.",
    "distractorExplanations": {
      "1": "Dit is enkelvoud bij hij/zij/het. Bij 'wij' is het meervoud: fietsen.",
      "2": "Dit is verleden tijd. 'Morgen' gaat niet over het verleden.",
      "3": "Dit is het voltooid deelwoord. Dat gebruik je met 'hebben': wij hebben gefietst."
    }
  },
  {
    "id": "SWW-E6-L105-004",
    "module": "SpellingWW",
    "difficulty": 105,
    "difficultyTier": 5,
    "levelCode": "E6",
    "group": 6,
    "question": "De hond heeft ... (spelen).",
    "options": ["gespeeld", "gespeelt", "speelde", "speelt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_na_heeft",
    "familyId": "SWW-VD-ZWAK-DT-KEUZE",
    "conceptId": "past_participle_weak_d_or_t_basic",
    "variantIndex": 1,
    "explanation": "Na 'heeft' gebruik je een voltooid deelwoord.\nHet werkwoord is 'spelen' en het voltooid deelwoord is: gespeeld.",
    "distractorExplanations": {
      "1": "Hier staat een t aan het einde, maar het juiste voltooid deelwoord is gespeeld.",
      "2": "Dit is verleden tijd. Na 'heeft' hoort het voltooid deelwoord.",
      "3": "Dit is tegenwoordige tijd. Na 'heeft' hoort het voltooid deelwoord."
    }
  },
  {
    "id": "SWW-E6-L105-005",
    "module": "SpellingWW",
    "difficulty": 105,
    "difficultyTier": 5,
    "levelCode": "E6",
    "group": 6,
    "question": "Het brood is ... (snijden).",
    "options": ["gesneden", "gesnijd", "sneed", "snijdt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_sterk",
    "familyId": "SWW-VD-STERK-BASIS",
    "conceptId": "past_participle_strong_basic",
    "variantIndex": 3,
    "explanation": "Na 'is' gebruik je een voltooid deelwoord.\n'Snijden' is een sterk werkwoord. Het voltooid deelwoord is: gesneden.",
    "distractorExplanations": {
      "1": "Dit bestaat niet als juiste vorm. Sterke werkwoorden hebben vaak een vaste vorm, hier is dat gesneden.",
      "2": "Dit is verleden tijd. Na 'is' hoort een voltooid deelwoord.",
      "3": "Dit is tegenwoordige tijd. Na 'is' hoort een voltooid deelwoord."
    }
  }
]
